import { format } from 'date-fns'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '../../../components/ui/card'
import { ptBR } from 'date-fns/locale'
import { BasicAvatar } from '../../../components/BasicAvatar'

type UserCardProps = {
  profileImageUrl: string
  name: string
  createdAt: string
}

export const UserCard = ({
  profileImageUrl,
  name,
  createdAt,
}: UserCardProps) => {
  return (
    <Card className="flex w-full flex-col gap-2 rounded-lg bg-white02 p-5">
      <CardHeader>
        <BasicAvatar name={name} profileImageUrl={profileImageUrl} />
      </CardHeader>
      <CardContent>
        <p className="text-2xl font-semibold">{name}</p>
      </CardContent>
      <CardFooter>
        <p className="text-sm font-medium text-[#9F9F9F]">
          Ingressou em{' '}
          {format(createdAt, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
        </p>
      </CardFooter>
    </Card>
  )
}
